import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
const COMMENT_SCROLL_PADDING = 8;
type UsePrV2ScrollToCommentWithOffsetArgs = {
  viewportTopOffset: number;
};
export function usePrV2ScrollToCommentWithOffset(t0) {
  const $ = _c(2);
  const {
    viewportTopOffset
  } = t0;
  let t1;
  if ($[0] !== viewportTopOffset) {
    t1 = element => {
      const rootNode = element.getRootNode();
      const isElementInShadowRoot = typeof ShadowRoot !== "undefined" && rootNode instanceof ShadowRoot && rootNode.host instanceof HTMLElement;
      const shadowHostSection = isElementInShadowRoot ? rootNode.host.closest("section") : null;
      const fileSection = element.closest("section") ?? shadowHostSection;
      const stickyHeader = fileSection?.querySelector("[data-pr-v2-file-header-sticky-wrap=\"true\"]");
      const stickyHeaderHeight = stickyHeader instanceof HTMLElement ? stickyHeader.getBoundingClientRect().height : 0;
      const scrollOffset = viewportTopOffset + stickyHeaderHeight + COMMENT_SCROLL_PADDING;
      element.scrollIntoView({
        behavior: "instant",
        block: "start"
      });
      const scrollContainer = document.getElementById("scrollable-content");
      const scrollContainerElement = scrollContainer instanceof HTMLElement ? scrollContainer : null;
      const hasScrollContainerElement = scrollContainerElement !== null;
      const isElementInScrollContainer = hasScrollContainerElement && scrollContainerElement.contains(element);
      const isFileSectionInScrollContainer = hasScrollContainerElement && fileSection instanceof HTMLElement && scrollContainerElement.contains(fileSection);
      const shouldOffsetScrollContainer = isElementInScrollContainer || isFileSectionInScrollContainer;
      const offsetScrollContainer = shouldOffsetScrollContainer ? scrollContainerElement : null;
      if (offsetScrollContainer) {
        offsetScrollContainer.scrollTop = Math.max(0, offsetScrollContainer.scrollTop - scrollOffset);
        return;
      }
      window.scrollBy(0, -scrollOffset);
    };
    $[0] = viewportTopOffset;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}